// Aliased target for `import ... "jquery"` / `require("jquery")`, so the app reuses
// the one window.jQuery from vendor_globals instead of a second copy.
// Must be CommonJS. A UMD lib that require()s an ESM default export gets the
// namespace ({ default: jQuery }), not jQuery, breaking `$.valHooks` etc.
module.exports = window.jQuery;
